// import React from "react";
// import { Route, Redirect } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const isLoggedIn = localStorage.getItem("logged");
//   return isLoggedIn ? <Redirect to="/" /> : children;
// };

// export default ProtectedRoute;

import React, { useEffect, useState } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import {
  API,
} from "./Helper";
import CustomLoader from "./CustomLoader";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("logged");
  const location = useLocation();
  // const [isAllowed, setIsAllowed] = useState(null);
  // const [ageConfirmed, setAgeConfirmed] = useState(localStorage.getItem("is18+") === "true");
   const [isAllowed, setIsAllowed] = useState(true);
  const [ageConfirmed, setAgeConfirmed] = useState(true);

  if (isAllowed === null || !ageConfirmed) return <CustomLoader/>;

  // Fix: Redirect unauthenticated users to login
  if (!isLoggedIn) return <Redirect to="/login" />;

  return children;
};

export default ProtectedRoute;
